import styled from 'styled-components';

export const Container = styled.div`
  > div {
    position: relative;
  }

  .shopping-icon {
    width: 1.4rem;
  }

  .quantity-itens-in-cart {
    position: absolute;
    bottom: 0.1rem;
    right: 0;
    background-color: var(--secondary_color);
    border-radius: 50%;
    font-weight: 900;
    font-size: 0.5rem;
    color: var(--black);
    text-align: center;
    padding: 0.1rem;
    width: 0.9rem;
  }

  @media (max-width: 360px) {
    .quantity-itens-in-cart {
      width: 0.7rem;
      height: 0.7rem;
      font-size: 0.45rem;
    }
  }
`;
